import Api from "./baseApi";
export default {
  searchFormulaMultiplier: formulaMultiplier => {
    let url = "/api/formulaMultipliers?v=1";
    if (formulaMultiplier.search) url += `&q=${formulaMultiplier.search}`;
    if (formulaMultiplier.state > -1) url += `&state=${formulaMultiplier.state}`;
    return Api.get(url);
  },
  getformulaMultipliers: () => Api.get("/api/formulaMultipliers"),
  getFormulaMultiplier: id => Api.get(`/api/formulaMultipliers/${id}`),
  putFormulaMultiplier: formulaMultiplier => Api.put(`/api/formulaMultipliers/${formulaMultiplier.id}`, formulaMultiplier),
  deleteFormulaMultiplier: formulaMultiplier => Api.delete(`/api/formulaMultipliers/${formulaMultiplier.id}`, formulaMultiplier),
  postFormulaMultiplier: formulaMultiplier => Api.post(`/api/formulaMultipliers`, formulaMultiplier),
  buyformulaMultipliers(formulaMultipliers, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.userAgent.indexOf("PhantomJS") > -1
        ? cb()
        : errorCb();
    }, 100);
  }
};
